import { PageViewEventLogger } from '@repo/tracking-service';

import { SurveyExpiredContainer } from '@/components/survey/expired/SurveyExpiredContainer';

function SurveyExpiredPage() {
  return (
    <PageViewEventLogger pageName={'survey_expired'}>
      <SurveyExpiredContainer />
    </PageViewEventLogger>
  );
}

export default SurveyExpiredPage;
